import {ActivatedRoute, Router} from '@angular/router';
import {Agende} from 'app/model/agende';
import {Component, NgZone, OnDestroy, OnInit, ViewChild} from '@angular/core';
import * as moment from 'moment';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {HttpClient} from "@angular/common/http";
import {Config} from "../../config.const";
import {Subscription} from "rxjs";
import {AppuntamentoSpecialisticoComponent} from "../appuntamento-specialistico/appuntamento-specialistico";
import {EasyuiDatagridComponent} from "../../easyui-ts/easyui-datagrid.component";
import {TextEditorComponent} from "../text-editor/text-editor.component";
import {ModalTextEditorComponent} from "../modal-text-editor/modal-text-editor.component";

@Component({
  selector: 'app-appuntamenti-specialistiche',
  templateUrl: './appuntamenti-specialistiche.html',
  styleUrls: ['./appuntamenti-specialistiche.css']
})
export class AppuntamentiSpecialisticheComponent implements OnInit, OnDestroy {

  teleconsulti: any[];
  teleconsultiSub: Subscription;

  saveModalSub: Subscription;
  saveWithNameModalSub: Subscription;
  closeModalSub: Subscription;

  // impostazioni griglia
  dataGridOptions: any;
  // oggetto griglia
  @ViewChild(EasyuiDatagridComponent) grid: EasyuiDatagridComponent;

  // oggetto editor
  @ViewChild(TextEditorComponent) editor: TextEditorComponent;

  constructor(private route: ActivatedRoute,
              private agende: Agende,
              private router: Router,
              private modalService: NgbModal,
              private ngZone: NgZone,
              private $http: HttpClient) {
    moment.locale('it');

    window['appuntamentiSpecialisticheComponentReference'] = {
      component: this,
      zone: this.ngZone,
      callopenMotivazioneEditor: (id) => this.openMotivazioneEditor(id),
      callopenVisitaEditor: (id) => this.openVisitaEditor(id),
    };

    this.dataGridOptions = {
      singleSelect: "true",
      columns: [
        [
          {
            title: 'Giorno e Ora',
            field: 'dataoraformattata',
            width: '10%'
          },
          {
            title: 'Nome Paziente',
            field: 'nome_paz',
            width: '20%'
          },
          {
            title: 'Cognome Paziente',
            field: 'cognome_paz',
            width: '20%'
          },
          {
            title: 'Data Nascita Paziente',
            field: 'natoil_paz',
            width: '12%'
          },
          {
            title: 'Motivazione visita',
            field: 'editor_motivazione',
            width: '20%',
            align: 'center'
          },
          {
            title: 'Referto visita',
            field: 'editor_visita',
            align: 'center'
          },
          {
            title: 'Teleconsulto',
            field: 'link_videochiamata_href',
            align: 'center'
          }
        ]
      ],
      fitColumns: true,
      // width: '100%',

      //view: scrollview,
      //autoRowHeight: true,

      // pagination: true,
      //pageSize: 20,
      // remoteFilter: false,
      // rowNumbers: true
      rowStyler: function (index, row) {
        if (row.passato === 1) {
          return 'background-color: #e1e1e1';
        }
      }
    };
  }

  loadData() {
    this.teleconsultiSub = this.$http.get(`${Config.baseURL}/teleconsulto/appuntamenti`).subscribe((response: any) => {
      this.teleconsulti = response;

      // aggiungo il link per l'edit
      response = response.map(row => {
        row['editor_motivazione'] = `
            <a 
            href="javascript:void(0)" 
            onclick="window.appuntamentiSpecialisticheComponentReference.callopenVisitaEditor(${row['id']})">
                <i class="fa fa-2x" aria-hidden="true">
                    <img src="/assets/icons/lentina.png" style="width: 1em" />
                </i>
            </a>
        `;

        row['editor_visita'] = `
            <a 
            href="javascript:void(0)" 
            onclick="window.appuntamentiSpecialisticheComponentReference.callopenMotivazioneEditor(${row['id']})">
                <i class="fa fa-2x" aria-hidden="true">
                    <img src="/assets/icons/referto.png" style="width: 1em" />
                </i>
            </a>
        `;

        row['link_videochiamata_href'] = `
          <a href="${row['link_videochiamata']}" target="_blank">
            <i class="fa fa-2x" aria-hidden="true">
                <img src="/assets/icons/telecameraceleste.png" style="width: 1.2em" />
            </i>
          </a>
        `;

        return row;
      });

      const dataForTable = {total: response.length, rows: response};

      // pulisco la griglia
      this.grid.loadDati({rows: [], total: 0});

      if (dataForTable.total > 0) {
        this.grid.loadDati(dataForTable);

        this.grid.updateOptions(this.dataGridOptions);
      } else {
        // todo: gestire eventualmente la non presenza di record
      }
    })
  }

  ngOnInit(): void {
    this.loadData();
  }

  ngOnDestroy(): void {
    if (this.teleconsultiSub) {
      this.teleconsultiSub.unsubscribe();
    }
    if (this.saveModalSub) {
      this.saveModalSub.unsubscribe();
    }
    if (this.saveWithNameModalSub) {
      this.saveWithNameModalSub.unsubscribe();
    }
    if (this.closeModalSub) {
      this.closeModalSub.unsubscribe();
    }
  }

  openAppuntamento(id: number) {
    const modalRef = this.modalService.open(AppuntamentoSpecialisticoComponent);
    modalRef.componentInstance.setId(id);
  }

  openMotivazioneEditor(id: number) {
    const modalRef = this.modalService.open(ModalTextEditorComponent, {windowClass: 'large-modal'});

    modalRef.componentInstance.setTitle('Referto visita');

    // salvo la nota dell'evento
    this.saveModalSub = modalRef.componentInstance.saveSubscription$.subscribe(data => {

      const teleconsulto = this.teleconsulti.find(t => t.id === data.id);

      teleconsulto.nota = data.nota;

      this.$http.post(
        `${Config.baseURL}/teleconsulto/appuntamento`,
        {event: teleconsulto}
      ).subscribe((response: any) => {
        this.loadData();
      });
    });
    this.saveWithNameModalSub = modalRef.componentInstance.saveWithNameSubscription$.subscribe(data => {
      modalRef.componentInstance.getEditor().print()
    });
    this.closeModalSub = modalRef.componentInstance.closeSubscription$.subscribe(data => {
    });

    modalRef.componentInstance.getEditor().show();

    // estraggo il teleconsulto scelto
    const teleconsulto = this.teleconsulti.find(t => t.id === id.toString());

    if (teleconsulto) {

      modalRef.componentInstance.setId(teleconsulto.id);

      modalRef.componentInstance.hideSaveWithNameButton();

      if (teleconsulto.note && teleconsulto.note.length > 0) {
        modalRef.componentInstance.getEditor().setText(teleconsulto.note);
      } else {
        modalRef.componentInstance.getEditor().setText(this.generateModelloNota(teleconsulto));
      }
    } else {
      alert("Anomalia,teleconsulto non trovato (id: " + id + ")");
    }
  }

  openVisitaEditor(id: number) {
    const modalRef = this.modalService.open(ModalTextEditorComponent, {windowClass: 'large-modal'});

    modalRef.componentInstance.setTitle('Motivazione visita');

    this.closeModalSub = modalRef.componentInstance.closeSubscription$.subscribe(data => {

    });
    modalRef.componentInstance.hideSaveButton();
    modalRef.componentInstance.hideSaveWithNameButton();
    modalRef.componentInstance.changeTextCloseButton('Esci');

    modalRef.componentInstance.getEditor().show();

    modalRef.componentInstance.getEditor().setReadOnly();

    // estraggo il teleconsulto scelto
    const teleconsulto = this.teleconsulti.find(t => t.id === id.toString());

    if (teleconsulto) {

      modalRef.componentInstance.setId(teleconsulto.id);

      modalRef.componentInstance.getEditor().setText(this.generaModelloMotivazone(teleconsulto));

    } else {
      alert("Anomalia,teleconsulto non trovato (id: " + id + ")");
    }
  }

  generateModelloNota(teleconsulto: any): string {
    return `
      <p>
        <strong>Nome:</strong> ${teleconsulto.nome_paz}<br>
        <strong>Cognome:</strong> ${teleconsulto.cognome_paz}<br>
        <strong>Anamnesi patologica remota:</strong><br>
        <strong>Anamnesi patologica prossima:</strong><br>
        <strong>Esame obiettivo:</strong><br>
        <strong>Terapia:</strong><br>
        <strong>Note:</strong><br>
      </p>
    `;
  }

  generaModelloMotivazone(teleconsulto: any): string {
    return `
      <p>
        ${this.nvl(teleconsulto.title, '-')}
            <br><br> 
        ${this.nvl(teleconsulto.descrizione, '-')}
      </p>
    `;
  }

  nvl(a: any, b: any) {
    return a == null ? b : a;
  }
}




// WEBPACK FOOTER //
// ./src/app/components/appuntamenti-specialistiche/appuntamenti-specialistiche.ts